import { render, staticRenderFns } from "./TreeList.vue?vue&type=template&id=5f12e4f5"
import script from "./TreeList.ts?vue&type=script&lang=ts&external"
export * from "./TreeList.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports